module.exports = __webpack_public_path__ + "img/impostor-bg.356e6bca.webp";